/**
 * Combine data from Y4 API response into option for ChartJS
 */

//import { getColor, rgbaColor } from 'helpers/utils';
//import { chartJsDefaultTooltip } from 'helpers/chartjs-utils';

const ChartJSBaseChart = ({ option, data }) => {
  option.data.labels = data.axisXData;
  option.data.datasets[0].data = data.series[0].data[0];
};

export default { ChartJSBaseChart };
